import type { CommonSVGProps } from './helpers';

export const DiscoverIcon = (props: CommonSVGProps) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2738_2422)">
        <path
          d="M12.18 5.82L10.827 9.87825C10.7534 10.0992 10.6293 10.2999 10.4646 10.4646C10.2999 10.6293 10.0992 10.7534 9.87825 10.827L5.82 12.18L7.173 8.12175C7.24664 7.90081 7.37071 7.70006 7.53538 7.53538C7.70006 7.37071 7.90081 7.24664 8.12175 7.173L12.18 5.82Z"
          stroke="#3D3D3D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <path
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke="#3D3D3D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_2738_2422">
          <rect fill="white" height="18" width="18" />
        </clipPath>
      </defs>
    </svg>
  );
};
